/* tslint:disable:no-shadowed-variable */
import { ModuleNames } from '@/store/module-names'
import { ActionNames, MutationNames } from './keys'
import { patchUnitQuery } from '@/jsonapi/Units'
import { UnitsState } from '@/store/modules/unit/types'

const state: UnitsState = {
  units: [],
}

const mutations = {
  [MutationNames.updateUnits](state, payload): void {
    state.units = payload
  },
}

const actions = {
  async [ActionNames.patchUnit]({ commit }, payload) {
    await patchUnitQuery(payload)
    // const results = camelcaseKeysDeep(await getUnitsQuery())
    commit(MutationNames.updateUnits, [])
  },
}

export default {
  name: ModuleNames.unit,
  namespaced: true,
  state,
  mutations,
  actions,
}
